import { render, staticRenderFns } from "./trading.vue?vue&type=template&id=6bd60e02&scoped=true&"
import script from "./trading.vue?vue&type=script&lang=js&"
export * from "./trading.vue?vue&type=script&lang=js&"
import style0 from "./trading.vue?vue&type=style&index=0&id=6bd60e02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd60e02",
  null
  
)

export default component.exports